import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { InputNumber, InputNumberChangeEvent } from 'primereact/inputnumber';
import { Labelled, LabelledProps } from './Labelled';

interface Props extends LabelledProps {
  value: number;
  onChange: (value: number) => void;
  autoFocus?: boolean;
  className?: string;
}

export const LabelledYear = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <InputNumber
        id={props.id}
        value={props.value || null}
        required={props.permissions ? props.permissions?.required : false}
        invalid={props.validation ? !props.validation?.valid : false}
        disabled={disabled}
        onChange={(event: InputNumberChangeEvent): void => props.onChange(event.value)}
        locale={intl.locale}
        autoFocus={props.autoFocus}
        className={props.className}
        useGrouping={false}
        min={-9999}
        max={9999}
        maxLength={4}
        maxFractionDigits={0}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
      />
    </Labelled>
  );
};
